import useOptimisticUpdate from "../../../services/ReactQuery/useOptimisticUpdate";
import Reviews from "../../../services/API/Reviews";
import { Stack, Box, Checkbox } from '@mui/material';
import moment from "moment";


export default function Answered({review}){

    const mutation = useOptimisticUpdate('reviews', Reviews.answer)
    
    let at = review.answeredAt;
    let date = at ? moment(at).format('DD/MM/YYYY') : '';

    const handleChange = () => {
        const copy = {...review};
        copy.answeredAt = review.answeredAt ? null : moment().format('YYYY-MM-DDTHH:mm:ss')
        return mutation.mutate(copy)
    }

    return <Stack>
        <Box>
            <Checkbox checked={at ? true : false} onChange={handleChange}/>
        </Box>
        <small>{date}</small>
    </Stack>
}
